import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { userApi } from '../userApi';
import { MutationKey } from '@shared/config';
import { type UpdateUserRequest, type User } from '../types';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useUpdateUser = (
  id: string
): UseMutationResult<
  User,
  AxiosError<TFormErrorResponse>,
  UpdateUserRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_USER],
    mutationFn: (data: UpdateUserRequest) => userApi.updateUser(id, data),
  });
};
